import { mergeObjects, processFinancialData } from "../components/CdpReports/services";
import { groupBy } from "./commonutils";
import { isBlankNullOrUndefined } from "./validations";

export const getAltPayFlag = (provider) => {
    const flag = provider?.altPay ??
        provider?.doctorPayVariables?.altPay ??
        provider?.doctorPayVariables?.Doctors?.[0]?.altPay ??
        provider?.profilesToBeUsed?.altPay;

    return Boolean(flag);
};

export const getAdjOrWriteOffbCare = (data, ABBR, getPracticeName) => {
    const doctorData = data.find((doctor) => doctor.ABBR?.toUpperCase() === ABBR?.toUpperCase());
    if (!doctorData) {
        return {
            production: { reportData: [] },
            adjustment: { reportData: [] },
            writeoff: { reportData: [] },
            hygienistRecords: [],
            isUkgHyn: false
        }
    }

    let bCareArr = [];
    if (!isBlankNullOrUndefined(doctorData.dataBCare)) {
        bCareArr = doctorData.dataBCare.map((item) => {
            item.price = item.bCare;
            item.age = item.Age;
            item.insurance = item.CarrierName;
            item.dateOfService = item.ProcDate;
            item.date = item.ProcDate;
            item.patientId = item.PatNum;
            item.practiceName = getPracticeName(item.Practice);
            item.practice = item.Practice;
            item.procCode = item.ProcCode;
            return item;
        });
        const result = mergeObjects(bCareArr);
        bCareArr = groupBy(result, 'ProcDate');
    }
    const writeoffArr = processFinancialData(doctorData.dataWriteOff, 'WriteOff', -1);
    const adjustmentArr = processFinancialData(doctorData.dataAdjustment, 'AdjAmt');

    // Extract all hygienist production records from all practices for UKG HYN contract type
    let allHygienistRecords = [];
    const isUkgHyn = doctorData.contractType === 'UKG HYN';
    if (isUkgHyn && doctorData.data) {
        Object.values(doctorData.data).forEach(practiceData => {
            const treatments = practiceData.hygienistProductionMatchingProviderTreatments;
            if (treatments && Array.isArray(treatments)) {
                allHygienistRecords = allHygienistRecords.concat(treatments);
            }
        });
    }

    return {
        production: { reportData: bCareArr },
        adjustment: { reportData: adjustmentArr },
        writeoff: { reportData: writeoffArr },
        hygienistRecords: allHygienistRecords,
        isUkgHyn: isUkgHyn
    }
}